export default require("../../node_modules/.pnpm/ndarray@1.0.19/node_modules/ndarray/ndarray.js");